import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withLazyLoading from '../../../../../hocs/withLazyLoading'
import type {State} from '../../../../../reducers/types'
import {getBuild, getHasDependants} from '../../../../../selectors'
import type {BuildId} from '../../../../../types'
import {resolveWebEntityLink, WebEntityType} from '../../../../../utils/entityLinks'
import {Namespace} from '../../../../../utils/namespace'

import BuildDependencies from './BuildDependants'
import {fetchHasDependantsQueue} from './BuildDependants.actions'

type Props = {
  buildId: BuildId
}

const mapStateToProps = (state: State, {buildId}: Props) => {
  const build = getBuild(state, buildId)
  const hasDependants = getHasDependants(state, buildId)
  return {
    buildUrl: resolveWebEntityLink(WebEntityType.BUILD, buildId),
    hasDependants,
    id: buildId,
    needsDetails: build != null && hasDependants == null,
  }
}

const actionCreators = {
  fetchDetails: fetchHasDependantsQueue,
}

export default compose(
  connect(mapStateToProps, actionCreators),
  withLazyLoading({
    namespace: Namespace.HAS_DEPENDANTS,
    ignoreFetcher: true,
  }),
)(BuildDependencies)
